import React from "react"
import Dropdown from "../../../../Dropdown/Dropdown"
import { options } from "./options"
import { setGenderType } from "../../useReducer/actionCreators"
import useOption from "./useOption"

const GenderTypeDropdown = ({ externalDispatch, selectedType }) => {
  const [option, setOption] = useOption(selectedType)
  return (
    <Dropdown
      label="Gender"
      id="gender_type_dropdown"
      options={options}
      value={option}
      onChange={(option) => {
        setOption(option)
        externalDispatch(setGenderType(option.id))
      }}
    />
  )
}
export default GenderTypeDropdown
